// Fundo da tela de descanso do totem: passa as mídias cadastradas em
// Cardápio → Banners → Totem. Vídeo toca até o fim (mudo), foto fica 8 s;
// ao terminar a lista, recomeça. Sem mídia, não renderiza nada (a tela usa
// o fundo padrão). Recarrega a lista a cada 10 min pra pegar mídia nova sem
// reiniciar o totem.

import { useEffect, useRef, useState } from "react";

import { bannerImageUrl } from "../cardapio-banners/lib/bannerImageUrl";
import { totemApi } from "./api";

const FOTO_MS = 8000;
const RECARREGAR_MS = 10 * 60 * 1000;

export default function TotemFundoMidias({ ativo = true, onMudou }) {
  const [midias, setMidias] = useState([]);
  const [idx, setIdx] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    let vivo = true;
    const carregar = async () => {
      try {
        const r = await totemApi.midias();
        const lista = (Array.isArray(r.data) ? r.data : []).filter((m) => m.enabled && m.image_url);
        if (vivo) { setMidias(lista); setIdx((i) => (lista.length ? i % lista.length : 0)); onMudou?.(lista.length); }
      } catch (_) { /* fundo é enfeite: silêncio */ }
    };
    carregar();
    const t = setInterval(carregar, RECARREGAR_MS);
    return () => { vivo = false; clearInterval(t); };
  }, []);

  const atual = midias[idx];
  const proxima = () => setIdx((i) => (midias.length ? (i + 1) % midias.length : 0));

  // Foto: avança sozinha após FOTO_MS. Vídeo: avança no onEnded.
  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (!ativo || !atual || atual.media_type === "video" || midias.length < 2) return undefined;
    timerRef.current = setTimeout(proxima, FOTO_MS);
    return () => clearTimeout(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [atual, ativo, midias.length]);

  if (!ativo || !atual) return null;
  const src = bannerImageUrl(atual.image_url);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" data-e2e="totem-fundo-midias" data-midia-idx={idx}>
      {atual.media_type === "video" ? (
        <video
          key={atual.id}
          src={src}
          autoPlay
          muted
          playsInline
          loop={midias.length === 1}
          onEnded={proxima}
          onError={proxima}
          className="w-full h-full object-cover"
        />
      ) : (
        <img key={atual.id} src={src} alt="" className="w-full h-full object-cover totem-midia-fade" onError={proxima} />
      )}
      {/* Só escurece embaixo, onde fica o botão — a arte de marketing aparece inteira */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-black/5" />
      <style>{`
        @keyframes totem-midia-fade { from { opacity: 0; transform: scale(1.03); } to { opacity: 1; transform: scale(1); } }
        .totem-midia-fade { animation: totem-midia-fade 900ms ease-out both; }
      `}</style>
    </div>
  );
}
